import { render, staticRenderFns } from "./gc-button-email.vue?vue&type=template&id=34d21f4c"
import script from "./gc-button-email.vue?vue&type=script&lang=js"
export * from "./gc-button-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports